import { createStore } from 'vuex';

const store = createStore({
  state: {
    backend: 'https://api.xsint-intelligence.com',
  },
  getters: {
    backend: state => state.backend,
  },

});

export default store;
